import React from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import CustomPhoneNumberInputField from '../../../components/FormCom/CustomPhoneNumberInputField';
import CustomSelectField from '../../../components/FormCom/CustomSelectField';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { TextInputField } from '../../../components/FormCom/FormField';
import NumberOnlyInputField from '../../../components/FormCom/NumberOnlyInputField';
import { TranslatingContainerContext } from '../../../components/TranslatingContainer/TranslatingContainerProvider';
import {
  SignUpBasicInfoDataType,
  signUpBasicInfoInitialValues,
  SignUpBasicInfoSchema,
} from '../../../models/auth/signUp/signUpBasicInfo.model';
import { signUpActions } from '../../../redux/slices/signUpSlice';
import { useAppDisPatch } from '../../../redux/store';

const businessTypeOptions: Record<string, string> = {
  'Sole Proprietor': 'sole proprietor',
  'Limited Liability Company': 'limited liability company',
  'Public Liability Company': 'public liability company',
};

const SignUpBasicInfo = () => {
  const dispatch = useAppDisPatch();
  const { setSliderIndexPos } = React.useContext(TranslatingContainerContext)!;

  const onSubmit = (value: SignUpBasicInfoDataType) => {
    dispatch(signUpActions.setBasicInfoSlider(value));
    setSliderIndexPos(1);
  };

  return (
    <Container>
      <FormComponent
        initialValues={signUpBasicInfoInitialValues}
        schema={SignUpBasicInfoSchema}
        onSubmit={onSubmit}
      >
        <TextInputField
          label='Business Name'
          name='businessName'
          id='businessName'
          type='text'
          placeholder='Name'
        />

        {/*  */}
        <CustomSelectField
          label='Business Type'
          placeholder='Select...'
          name='businessType'
          id='businessType'
          optionData={Object.keys(businessTypeOptions)}
        />
        <NumberOnlyInputField
          label='Business Registration Number'
          name='registrationNumber'
          id='registrationNumber'
          type='text'
          placeholder='Reg. Number'
          maxLength={7}
        />
        <TextInputField
          label='Email Address'
          name='email'
          id='email'
          type='email'
          placeholder='Email'
        />
        <CustomPhoneNumberInputField
          label='Phone Number'
          name='phoneNumber'
          id='phoneNumber'
          placeholder='8XXXXXXXX'
          fixedCountry='NG'
          maxLength={10}
        />
        <FormSubmitButton className='topMargin large'>Next</FormSubmitButton>
      </FormComponent>
    </Container>
  );
};

const Container = styled.div`
  flex-direction: column;
  display: flex;
`;

export default SignUpBasicInfo;
